import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getItems, itemsValue, priceMassive, clearMessage } from "../../redux/actions/actionItem";
import LoadingIcons from "react-loading-icons";
import PreciosModCard from "./preciosModCard";
import { exportToExcel } from "../../utils/botonExcelPrecios";
import Swal from "sweetalert2";

export default function PreciosMod(){
    const items = useSelector((state)=> state.items.allItems);
    const {message, error} = useSelector((state) => state.items);
    const dispatch = useDispatch();
    const [itemFind, setItemFind] = useState();
    const [itemInput, setItemInput] = useState("")
    const [modifiedItems, setModifiedItems] = useState([]);
    const [incremento, setIncremento] = useState(0);

    console.log(message);
    console.log(error);
    
    
    useEffect(() => {
      dispatch(getItems())
    }, [dispatch])
    console.log(items)
    
    useEffect(() => {
      dispatch(clearMessage());
    }, [dispatch]);
    
    const isEmpty = (obj) => Object.keys(obj).length === 0;
    useEffect(() => {
      if(message && !isEmpty(message)){
        Swal.fire(message?.message);
        dispatch(clearMessage());

        setTimeout(() => {
          dispatch(getItems());          
        }, 500);
        
        setModifiedItems([]);
      }        
    }, [message, dispatch])
    
    useEffect(() => {
      if(error && !isEmpty(error)){
        Swal.fire(error.error);
        dispatch(clearMessage());
      }
    }, [error, dispatch])
    

    const handleChange = (e) => {
        const { value } = e.target
        setItemInput(value)
      }
  
      const filterItem = () => {
         console.log(itemInput);
          if (itemFind === undefined) {
            let result = items.filter((e) => {
              if (
                e.name
                  .toString()
                  .toLowerCase()
                  .includes(itemInput.toLowerCase())
                  ) {
                //console.log(e)
                return e;
              }
            });
            setItemFind(result);
          } else {
            let result = itemFind.filter((e) => {
              if (
                e.name
                .toString()
                .toLowerCase()
                .includes(itemInput.toLowerCase())
                ) {
                  //console.log(e)
                  return e;
                }
              });
              setItemFind(result);
            }
          };
  
          const handleLimpiar = () => {
            console.log(itemFind);
            setItemFind(items)
          }

          const handlePriceChange = (id, newPrice) => {
            console.log(id, newPrice);
            setModifiedItems(prev => {
            const filtered = prev.filter(item => item.id !== id);
            return [...filtered, { id, price: newPrice }];
            });
          };

          console.log(modifiedItems);
          

          const handleActualizar = () => {
            console.log(modifiedItems);
            dispatch(itemsValue({itemsArray: modifiedItems}));
          }
         

          const handleExcel = () => {
            console.log(items);
            
            exportToExcel({dataExcel: items});
          }

          const handleIncrementoMasivo = () => {
            console.log(incremento);            
            let inc = Number(incremento)
            if(inc === 0 || isNaN(inc)) {
              Swal.fire("Debe ingresar un numero");
            } else {
              console.log("FUNCIONA");
              dispatch(priceMassive({porcentaje: inc}));
            }

          } 

    return (
        <div className="min-w-full bg-gray-900">
            <div className="m-5">
            <div>
                <p className="text-xl pb-8 underline  text-orange-500">Informes - Articulos</p>
            </div>
            <div className="flex flex-row h-20 bg-cyan-900">
              <div>
            <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-600 placeholder-yellow-400"
              type="text"
              placeholder="Articulo"
              onChange={handleChange}              
            />
          </div>
          <div className="w-56 text-center">
            <button className="w-16 ml-14 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={filterItem}>Buscar</button>
            <button className="w-16 h-6 ml-2 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={handleLimpiar}>Limpiar</button>
          </div>
          </div>
          <div className="ml-20">
            <button className="text-orange-500 ml-5 bg-slate-500 w-32 mt-1 hover:bg-slate-200 hover:text-black" onClick={handleExcel}>
                Descargar Excel
            </button>
          </div>
          <div className="ml-40">
            <button className="text-orange-500 ml-5 bg-slate-500 w-28 mt-1 hover:bg-slate-200 hover:text-black" onClick={handleActualizar}>
                Actualizar Valores
            </button>
          </div>
          <div className="ml-20">
             <p className="text-orange-500">Incremento Masivo</p>
             <div className="flex">
              <p className="text-orange-500">Ingrese porcentaje</p>
            <input
              className="mt-2 ml-2 border border-slate-700 rounded w-20 h-4 text-center bg-cyan-600 placeholder-yellow-400"
              type="number"  
              placeholder="%"
              onChange={(e)=>{setIncremento(e.target.value)}}
            />
            </div>
            <button className="text-orange-500 ml-5 bg-slate-500 w-28 mt-1 hover:bg-slate-200 hover:text-black" onClick={handleIncrementoMasivo}>
              Incrementar
            </button>
          </div>
            </div>
            <div className="">
                <div className="flex flex-row  text-orange-500">
                    <div className="mb-2 w-12 text-[14px] font-bold text-center">N° Item</div>
                    <div className="mb-2 w-60 text-[14px] font-bold text-left pl-2">Nombre</div>
                    <div className="mb-2 w-6/12 text-[14px] font-bold text-left ">Descripcion</div>
                    <div className="mb-2 w-14 text-[14px] font-bold text-center">Stock</div>
                    <div className="mb-2 w-14 text-[14px] font-bold text-center">Stock Total</div>
                    <div className="mb-2 w-28 text-[14px] font-bold text-center">Valor</div>
                    {/* <div className="w-30">Eliminar</div> */}
                </div>
                {items.length === 0 ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> :
                itemFind === undefined ?
                items.map(e=> (
                    <PreciosModCard
                    key={e._id}
                    id={e._id}
                    idItem={e.idItem}
                    name={e.name}
                    description={e.description}
                    stock={e.stock}
                    stockTotal={e.stockTotal}
                    value={e.value}
                    onPriceChange={handlePriceChange}                    
                    />
                ))
            :
            itemFind.map(e=> (
                <PreciosModCard
                key={e._id}
                id={e._id}
                idItem={e.idItem}
                name={e.name}
                description={e.description}
                stock={e.stock}
                stockTotal={e.stockTotal}
                value={e.value}
                onPriceChange={handlePriceChange}
                />
            ))
            }
            </div>
            </div>
        </div>
    )
}

/*
function PrecioMod({ items }) {
  const [modifiedItems, setModifiedItems] = useState([]);

  const handlePriceChange = (id, newPrice) => {
    setModifiedItems(prev => {
      const filtered = prev.filter(item => item.id !== id);
      return [...filtered, { id, price: newPrice }];
    });
  };

  const handleSubmit = async () => {
    await fetch("/api/items/bulk-price", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: modifiedItems })
    });
  };

  return (
    <>
      {items.map(item => (
        <PrecioModCard
          key={item._id}
          item={item}
          onPriceChange={handlePriceChange}
        />
      ))}

      <button onClick={handleSubmit}>
        Actualizar precios
      </button>
    </>
  );
}
*/